module.exports = __webpack_public_path__ + "img/baseline-arrow_upward-24px.dd3d545b.svg";